<ejs-dialog #addDialog
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onDialogClose($event)"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.administration.zone-device-details.form.title-add' | translate}}
  </ng-template>
  <ng-template #content>
    <form id="zoneDeviceAddForm" [formGroup]="addForm" autocomplete="off">
      <div class="row">
        <div class="col-12">
          <label class="control-label required">{{'i18n.domain.administration.zone-device-details.form.brand' | translate}}</label>
          <ejs-dropdownlist [dataSource]="deviceBrands"
                            [fields]="enumDropdownSettings"
                            id="brand"
                            [showClearButton]="true"
                            formControlName="brand">
            <ng-template #itemTemplate let-data>
              {{data.text | translate}}
            </ng-template>
            <ng-template #valueTemplate let-data>
              <span class='numeric-enum-drop-down-value'>{{data.text | translate}}</span>
            </ng-template>
          </ejs-dropdownlist>
          <app-error-messages [control]="addForm.controls.brand"></app-error-messages>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <label class="control-label required">{{'i18n.domain.administration.zone-device-details.form.deviceType' | translate}}</label>
          <ejs-dropdownlist [dataSource]="deviceTypes"
                            [fields]="enumDropdownSettings"
                            id="deviceType"
                            [showClearButton]="true"
                            formControlName="deviceType">
            <ng-template #itemTemplate let-data>
              {{data.text | translate}}
            </ng-template>
            <ng-template #valueTemplate let-data>
              <span class='numeric-enum-drop-down-value'>{{data.text | translate}}</span>
            </ng-template>
          </ejs-dropdownlist>
          <app-error-messages [control]="addForm.controls.deviceType"></app-error-messages>
        </div>
      </div>
    </form>

  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2"
            (click)="closeAdd()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary"
            [disabled]="!addForm.valid"
            (click)="initializeDevice()">
      {{'i18n.shared.ok' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
